<template>
  <div class="home-v2">
    <div style="display:flex">
      <Sidebar />
      <Main />
    </div>
    <div class="request-container">
      <router-view />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    Loading: () => import('@/components/V2/GlobalLoading'),
    Sidebar: () =>
      import('@/components/dashboard/sidebar/sidebar-monitoring.vue'),
    Main: () => import('@/components/dashboard/main-monitoring/main.vue'),
  },
  data() {
    return {}
  },

  async created() {
    await this.choosedDateRange(3)
    await this.$store.dispatch('monitoringStore/getHeader')
    await this.$store.dispatch('monitoringStore/getDetailSioByVendor')
    await this.$store.dispatch('monitoringStore/getSioExpireSoon')
    await this.$store.dispatch('monitoringStore/getExpireSoonK3lKplh')
    await this.$store.dispatch('monitoringStore/getK3lStatus')
    await this.$store.dispatch('monitoringStore/getKplhStatus')
    await this.$store.dispatch('monitoringStore/getSioByVendor')
    await this.$store.dispatch('monitoringStore/getSioByActivity')
    await this.$store.dispatch('monitoringStore/getVendorLegalDoc')
  },

  methods: {
    async choosedDateRange(value) {
      let thisday = new Date()
      thisday.setHours(0, 0, 0, 0)
      let monthBefore = new Date()
      switch (value) {
        case 3:
          monthBefore.setDate(thisday.getDate() - 90)
          break
        case 6:
          monthBefore.setDate(thisday.getDate() - 180)
          break
        case 12:
          monthBefore.setDate(thisday.getDate() - 369)
          break

        default:
          break
      }

      thisday = moment(thisday).format('YYYY-MM-DD')
      let startDate = moment(monthBefore).format('YYYY-MM-DD')

      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'date_range',
        value,
      })
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'start',
        value: startDate,
      })
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'end',
        value: thisday,
      })
      // await this.$store.dispatch('vaStore/filterDate')
    },
  },
}
</script>
